import { SystemDao } from '@/dao';
import { version } from '../../package.json';
import { computed, onMounted, ref } from 'vue';
import type { ServerTime } from '@/objects/generated';

export const useSystem = () => {
    // The version of the frontend
    const frontendVersion = ref<string>(version);

    // Store the server time object
    const serverTime = ref<ServerTime | null>(null);

    // The version of the backend
    const backendVersion = computed(() => {
        return serverTime.value?.Version;
    });

    onMounted(async () => {
        serverTime.value = await SystemDao.GetServerTime();
    });

    return { frontendVersion, backendVersion, serverTime };
};
